/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgChrome(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M3.916 7.5A9.208 9.208 0 002.75 12c0 4.592 3.346 8.403 7.733 9.126l2.596-4.5a4.75 4.75 0 01-5.292-2.431L3.917 7.5zM3.304 5.68A10.702 10.702 0 001.25 12c0 5.51 4.146 10.052 9.489 10.677A10.856 10.856 0 0012 22.75c5.937 0 10.75-4.813 10.75-10.75a10.715 10.715 0 00-.916-4.35A10.752 10.752 0 0012 1.25c-3.519 0-6.642 1.69-8.604 4.304a.746.746 0 00-.092.125zm1.55.447l2.6 4.495A4.752 4.752 0 0112 7.25h7.939A9.245 9.245 0 0012 2.75a9.231 9.231 0 00-7.146 3.376zM20.663 8.75h-5.199A4.733 4.733 0 0116.75 12c0 .936-.27 1.808-.738 2.544l-3.867 6.705A9.25 9.25 0 0020.663 8.75zm-5.814 4.814a3.25 3.25 0 10-5.743-.083l.083.144c.012.02.023.041.033.062A3.248 3.248 0 0012 15.25a3.247 3.247 0 002.732-1.49l.078-.135a.761.761 0 01.04-.06z'
      />
    </svg>
  );
}

export default SvgChrome;
